import { render, staticRenderFns } from "./NotJoin.vue?vue&type=template&id=6601b3f4"
import script from "./NotJoin.vue?vue&type=script&lang=js"
export * from "./NotJoin.vue?vue&type=script&lang=js"
import style0 from "./NotJoin.vue?vue&type=style&index=0&id=6601b3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports